import { addAllValue } from 'src/utils/v5/DataTrees'

export const CCM_CODES = ['99490', '99439', '99487', '99489', '99491', '99437']
export const COCM_CODES = [
  '99492',
  '99493',
  '99494',
  'G2214',
  'T2022',
  'MCRNP',
  'MCREP',
  'MCDNP',
  'MCDEP'
]
export const RPM_CODES = ['99454', '99457', '99458', '99470', '99445']
export const RTM_CODES = ['98976', '98977', '98980', '98981']
export const BHI_CODES = ['99484']
export const NO_PROGRAM_CODES = ['G0506']
export const APCM_CODES = ['G0556', 'G0557', 'G0558']
export const PIN_CODES = ['G0023', 'G0024', 'G0140', 'G0146']
export const CHI_CODES = ['G0019', 'G0022']
export const TCM_CODES = ['99495', '99496']
export const PCM_CODES = ['99424', '99425', '99426', '99427']

export const CHECKING_RPM_CODES = ['99453', '99454']
export const CHECKING_RTM_CODES = ['98975', '98976', '98977']

export const PATIENT_CONSENT_STATUS = new Map([
  [
    1,
    {
      key: 1,
      label: 'Sent',
      value: 1,
      className: 'status-sent'
    }
  ],
  [
    2,
    {
      key: 2,
      label: 'Failed',
      value: 2,
      className: 'status-failed'
    }
  ],
  [
    3,
    {
      key: 3,
      label: 'Delivered',
      value: 3,
      className: 'status-delivered'
    }
  ],
  [
    4,
    {
      key: 4,
      label: 'Expired',
      value: 4,
      className: 'status-expired'
    }
  ],
  [
    5,
    {
      key: 5,
      label: 'Signed',
      value: 5,
      className: 'status-signed'
    }
  ]
])

export const PATIENT_CONSENT_STATUS_FOR_DROPDOWN_WITH_ALL = addAllValue({
  list: Array.from(PATIENT_CONSENT_STATUS).map(([key, item]) => ({
    key,
    ...item
  }))
})

export const GOAL_DURATIONS = new Map([
  [
    'shortTerm',
    {
      title: 'Short-Term',
      value: 'shortTerm'
    }
  ],
  [
    'longTerm',
    {
      title: 'Long-Term',
      value: 'longTerm'
    }
  ]
])

export const GOAL_DURATION_OPTIONS = Array.from(GOAL_DURATIONS).map(
  ([key, { title, value }]) => ({ key, value, title, label: title })
)
